import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggle', 'actualInfo']

  connect () {
    this.updateActualInfoVisibility()
  }

  toggleChanged () {
    this.updateActualInfoVisibility()
  }

  updateActualInfoVisibility () {
    const show = this.toggleTarget.checked
    this.actualInfoTargets.forEach(col => {
      col.style.display = show ? '' : 'none'
      // トグルOFF時はinput/select/hiddenをdisabledに
      col.querySelectorAll('input, select').forEach(el => {
        el.disabled = !show
      })
    })
  }
}
